exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3_bhL{background-color:-wix-colors-backgroundColor}.-A2_X{color:-wix-colors-buttonsAndLinksColor}", ""]);

// exports
exports.locals = {
	"spinner-container": "_3_bhL",
	"spinnerContainer": "_3_bhL",
	"spinner": "-A2_X"
};